@if (!isSearching) {
  <button class="search__button" aria-label="Search" (click)="navigateToSearchResults()" ftrTooltip message="Search">
    <ftr-icon icon="Search" color="Grey" align="Top" />
  </button>
} @else {
  <ftr-search-bar [courtSystemId]="courtSystemId" [searchTerms]="searchContext()?.searchTerms ?? ''" />
}
